const meta_data = {
    "meta.title.home": "1-DAY ACUVUE® DEFINE®",
    "meta.desc.home": "融合自然、科學與藝術的每日即棄鏡片，助你保持眼睛健康，綻放動人光彩。",
    "meta.title.vm": "虛擬試戴",
    "meta.desc.vm": "尋找、試戴最適合您的日拋 ACUVUE® DEFINE® 系列。",
    "meta.title.discover": "探索 Define® 系列目錄",
    "meta.desc.discover": "探索 Classic 經典大地色及 Fresh 大自然色系列，打造雙眸自然美感。",
    "meta.title.classic": "<探索 Define® Classic 經典大地色系>",
    "meta.desc.classic": "1-DAY ACUVUE® DEFINE® 經典大地色調，瞬間提亮深邃明眸，呈現炫目本色。",
    "meta.title.fresh": "<探索 Define® Fresh 大自然色系>",
    "meta.desc.fresh": "1-DAY ACUVUE® DEFINE® 玩味大自然色調，打造精緻大眼，演繹你的「睛」彩生活。",
}

export default meta_data;